var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesBrIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 806,
    height: 731,
    viewBox: "0 0 806 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.378 57.7721L728.407 439.342C793.154 493.636 801.611 590.125 747.296 654.856C722.37 684.562 688.556 702.417 653.003 707.794L653.005 707.999V730.009C694.872 724.484 734.874 703.886 764.154 668.992C826.279 594.954 816.606 484.59 742.548 422.489L287.519 40.9191C213.461 -21.1828 103.063 -11.5067 40.938 62.5314C-21.1874 136.569 -11.5141 246.933 62.5435 309.035L185.001 411.723V383.011L76.6849 292.182C11.9373 237.887 3.48013 141.398 57.7954 76.6674C112.111 11.937 208.63 3.47724 273.378 57.7721Z",
    fill: "url(#paint0_linear_1008_4397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1008_4397",
    x1: 583.506,
    y1: -65.6722,
    x2: 561.949,
    y2: 734.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333417,
    stopColor: "#D0FBEF",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#778DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesBrIc);
export default __webpack_public_path__ + "static/media/companiesBr_ic.25676bb2.svg";
export { ForwardRef as ReactComponent };